import styled from "styled-components";
import { space, background } from "styled-system";

const Box = styled.div`
  ${space}
  ${background}
`;

export default Box;
